import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../../animations/form-error';
import { BasePageComponent } from '../../../../base-page';
import { Validators as ValidatorsModel } from '../../../../../model/champs_formulaire/validators.model';
import { Subject } from 'rxjs';
import { BaseService } from '../../../base/base.service';
import { ValidatorService } from '../../validators/validator.service';
import { MatDialogRef } from '@angular/material/dialog';
import { FormService } from '../../../../../shared/services/form.service';
import { ValidatorColumnName } from '../../validators/validator-column-name';
import { UntypedFormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../../interfaces/app-state';
import { HttpService } from '../../../../../services/http/http.service';
import { takeUntil } from 'rxjs/operators';
import { TypeInputFormModel } from '../../../../../model/champs_formulaire/type-input-form.model';
import { TypeInputFormService } from '../type-input-form.service';
import { TypeInputFormColumnName } from '../type-input-form-column-name';

/**
 * Permet de gérer la suppression d'un country
 */
@Component({
  selector: 'app-type-input-form-delete',
  templateUrl: './type-input-form-delete.component.html',
  animations: [fadeIn]
})
export class TypeInputFormDeleteComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  countrySelected: TypeInputFormModel;
  private subs$ = new Subject<void>();
  isDeleting = false;
  successDelete = false;
  serverHasError = false;
  hasDelete = false;

  constructor(
    private baseService: BaseService,
    private countryService: TypeInputFormService,
    private dialogRef: MatDialogRef<TypeInputFormDeleteComponent>,
    private formService: FormService,
    private columnName: TypeInputFormColumnName,
    private fb: UntypedFormBuilder,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct type_input_form delete');
  }

  ngOnInit(): void {
    console.log('## init type_input_form delete.');
    this.countryService.getObjetSelectObs()
      .pipe(takeUntil(this.subs$)).subscribe((res) => {
      console.log('## get type_input_form selected');
      try {
        console.log('## data: ', res);
        this.countrySelected = res;
      } catch (e) {
        console.log('## error get type_input_form delete: ' + e.message);
      }
      super.setLoaded();
    });
  }

  ngOnDestroy() {
    console.log('## destroy type_input_form delete');
    this.formService.free(this.subs$);
    this.countryService.setObjetSelectObs(undefined);
  }

  closeModal() {
    console.log('## close delete type_input_form');
    this.dialogRef.close();
  }

  delete() {
    console.log('## deleting type_input_form');
    this.isDeleting = true;
    this.serverHasError = false;
    this.successDelete = false;
    this.countryService.delete(this.countrySelected.id,
      this.countryService.resourceUrl).subscribe(
      response => {
        console.log('## success delete type_input_form');
        this.serverHasError = false;
        this.successDelete = true;
        this.isDeleting = false;
        this.hasDelete = true;
        this.responseFromServer();
        this.countryService.getAllObjet();
      }, error => {
        console.log('## error delete type_input_form');
        this.serverHasError = true;
        this.successDelete = false;
        this.isDeleting = false;
        this.responseFromServer();
      });
  }

  private responseFromServer() {
    setTimeout(() => {
      this.isDeleting = false;
    }, 300);
  }
}
